export default "__VITE_ASSET__CTG1wPAq__"